export default __webpack_public_path__ + "static/media/sketch-01.32cda442.png";